export enum AppRoute {
  HOME = '/',
  VALIDATE = 'validate',
  VALIDATE_ID = ':id',
  NOT_FOUND = '*',
}
